import { sanitizeInput } from "src/utils/utils";
class mfnSearchRequest {
  orderId: String;

  constructor(orderId: string) {
    orderId = sanitizeInput(orderId)
    this.orderId = orderId;
  }
}

export default mfnSearchRequest;